// @ts-nocheck
// T7 stick component — Shopify port.
// The .t7c markup is inlined directly in elemence-standards-elemix.liquid, so
// this script no longer fetches a partial or mounts new DOM. It just finds
// each `.t7c` already on the page, sizes it to its parent column, and runs
// the intro animation (line draw → swirls + video fade → text stagger).
// Hover lifts the stick + intensifies glow (pure CSS). Click on the visual
// replays the stick video from midpoint without re-running line/text/swirls.
(function () {
  function readTimings(rootEl) {
    const cs = getComputedStyle(rootEl);
    const ms = (name, fallback) => {
      const raw = cs.getPropertyValue(name).trim();
      const n = parseFloat(raw);
      return isFinite(n) ? n : fallback;
    };
    return {
      lineDur:    ms('--anim-line-dur',    1600),
      textBase:   ms('--anim-text-base',   0),
      textStep:   ms('--anim-text-step',   400),
      textDur:    ms('--anim-text-dur',    1550),
      videoStart: ms('--anim-video-start', 250),
      videoDur:   ms('--anim-video-dur',   1950),
      v320Start:  ms('--anim-v320-start',  400),
      v320Dur:    ms('--anim-v320-dur',    1000),
      v321Start:  ms('--anim-v321-start',  100),
      v321Dur:    ms('--anim-v321-dur',    1000),
      // Fraction of video duration where the stick visually rests (front face).
      // 0 = first frame, 0.5 = midpoint, 1 = last frame.
      restFrac:   ms('--anim-video-rest',  0),
    };
  }

  const initialized = new WeakSet();
  const instances = [];

  // Native design width — matches `width: 700px` on `.t7c` in the CSS.
  const COMPONENT_W = 700;

  function fitToHost(rootEl, hostEl) {
    const update = () => {
      const hostW = hostEl.clientWidth;
      if (!hostW) return;
      const scale = hostW / COMPONENT_W;
      rootEl.style.setProperty('--t7c-fit-scale', scale);
    };
    update();
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(update);
      ro.observe(hostEl);
    } else {
      window.addEventListener('resize', update);
    }
  }

  function initAnimation(rootEl) {
    const lineEls = rootEl.querySelectorAll('.t7c-line');
    const textEls = [
      rootEl.querySelector('.t7c-text--1'),
      rootEl.querySelector('.t7c-text--2'),
      rootEl.querySelector('.t7c-text--3'),
    ].filter(Boolean);
    const stickEl = rootEl.querySelector('.t7c-stick');
    const v320El  = rootEl.querySelector('.t7c-swirl--v320');
    const v321El  = rootEl.querySelector('.t7c-swirl--v321');
    const v       = rootEl.querySelector('.t7c-stick__video');
    if (!v || !stickEl) return { replay: () => {}, playVideo: () => {} };

    let introTimer = null;

    function restTime() {
      const T = readTimings(rootEl);
      if (!(isFinite(v.duration) && v.duration > 0)) return 0;
      const frac = Math.min(1, Math.max(0, T.restFrac));
      // Nudge slightly off the very last frame so the video doesn't immediately
      // fire `ended` if we pause exactly at duration.
      return frac >= 1 ? Math.max(0, v.duration - 0.05) : v.duration * frac;
    }

    function playIntro() {
      const T = readTimings(rootEl);

      lineEls.forEach((el) => { el.classList.remove('t7c-anim-line'); });
      textEls.forEach((el) => { el.classList.remove('t7c-anim-text'); el.style.animationDelay = ''; });
      stickEl.classList.remove('t7c-anim-video'); stickEl.style.animationDelay = '';
      if (v320El) { v320El.classList.remove('t7c-anim-swirl'); v320El.style.animationDelay = ''; }
      if (v321El) { v321El.classList.remove('t7c-anim-swirl'); v321El.style.animationDelay = ''; }

      const halfTime = restTime();
      try { v.pause(); } catch (e) { /* ignore */ }
      v.loop = false;
      v.currentTime = halfTime;

      if (introTimer) { clearTimeout(introTimer); introTimer = null; }

      void rootEl.offsetWidth;

      lineEls.forEach((el) => el.classList.add('t7c-anim-line'));
      textEls.forEach((el, i) => {
        el.style.animationDelay = ((T.textBase + i * T.textStep) / 1000) + 's';
        el.classList.add('t7c-anim-text');
      });
      stickEl.style.animationDelay = (T.videoStart / 1000) + 's';
      stickEl.classList.add('t7c-anim-video');
      if (v320El) { v320El.style.animationDelay = (T.v320Start / 1000) + 's'; v320El.classList.add('t7c-anim-swirl'); }
      if (v321El) { v321El.style.animationDelay = (T.v321Start / 1000) + 's'; v321El.classList.add('t7c-anim-swirl'); }

      setTimeout(() => {
        v.currentTime = halfTime;
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }, T.videoStart);

      const totalMs = Math.max(
        T.lineDur,
        T.textBase + 2 * T.textStep + T.textDur,
        T.videoStart + T.videoDur,
        T.v320Start + T.v320Dur,
        T.v321Start + T.v321Dur
      ) + 200;

      introTimer = setTimeout(() => {
        try { v.pause(); } catch (e) { /* ignore */ }
        v.currentTime = halfTime;
      }, totalMs);
    }

    let clickLocked = false;
    function playVideo() {
      if (clickLocked) return;
      clickLocked = true;
      if (introTimer) { clearTimeout(introTimer); introTimer = null; }
      try { v.pause(); } catch (e) { /* ignore */ }
      v.loop = false;
      v.currentTime = restTime();
      const p = v.play();
      if (p && p.catch) p.catch(() => { clickLocked = false; });
    }
    v.addEventListener('ended', () => {
      try { v.pause(); } catch (e) { /* ignore */ }
      v.currentTime = restTime();
      clickLocked = false;
    });

    // Kick off the intro only once the visual scrolls into view — Shopify
    // pages tend to be long, and firing on load wastes the moment.
    const INITIAL_DELAY_MS = 300;
    let kicked = false;
    const kickoff = () => {
      if (kicked) return;
      kicked = true;
      setTimeout(playIntro, INITIAL_DELAY_MS);
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (v.readyState >= 1) kickoff();
            else v.addEventListener('loadedmetadata', kickoff, { once: true });
            io.disconnect();
          }
        });
      }, { threshold: 0.2 });
      io.observe(rootEl);
    } else {
      if (v.readyState >= 1) kickoff();
      else v.addEventListener('loadedmetadata', kickoff, { once: true });
    }

    return { replay: playIntro, playVideo };
  }

  function initEl(rootEl) {
    if (!rootEl || initialized.has(rootEl)) return;
    initialized.add(rootEl);

    const host = rootEl.parentElement;
    if (host) fitToHost(rootEl, host);

    const api = initAnimation(rootEl);
    instances.push({ rootEl, replay: api.replay });

    const clickTarget = host || rootEl;
    clickTarget.addEventListener('click', () => {
      try { api.playVideo(); } catch (e) { /* ignore */ }
    });

    document.dispatchEvent(new CustomEvent('stick-component:ready', {
      detail: { rootEl, replay: api.replay }
    }));
  }

  function initAll() {
    document.querySelectorAll('.t7c').forEach(initEl);
  }

  window.stickComponentReplayAll = function () {
    instances.forEach((inst) => { try { inst.replay(); } catch (e) { /* ignore */ } });
  };
  window.stickComponentInstances = instances;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor swaps section markup live — re-init on each event.
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
